var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.41894C4.00821 1.41894 5.21429 2.00858 5.21429 3.58797C5.21429 4.49769 4.53857 5.55483 3.25 6.67093C1.96143 5.55483 1.28571 4.49348 1.28571 3.58797C1.28571 2.00858 2.49179 1.41894 3.25 1.41894ZM3.25 0.576599C1.96536 0.576599 0.5 1.61268 0.5 3.58797C0.5 4.90202 1.41536 6.28767 3.25 7.73649C5.08464 6.28767 6 4.90202 6 3.58797C6 1.61268 4.53464 0.576599 3.25 0.576599Z",
    fill: "#BFC3C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 2.68243C2.81786 2.68243 2.46429 3.06149 2.46429 3.52477C2.46429 3.98806 2.81786 4.36711 3.25 4.36711C3.45838 4.36711 3.65823 4.27837 3.80558 4.1204C3.95293 3.96243 4.03571 3.74818 4.03571 3.52477C4.03571 3.30137 3.95293 3.08712 3.80558 2.92915C3.65823 2.77118 3.45838 2.68243 3.25 2.68243ZM0.5 8.15765H6V8.99999H0.5V8.15765Z",
    fill: "#BFC3C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6f9379e122f6e78739770b0a842c654b.svg";
export { ForwardRef as ReactComponent };